import React, { useState, useEffect } from 'react';
import { getFirestore, collection, addDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";

const db = getFirestore();

function ReminderInput() {
  const [text, setText] = useState('');
  const [date, setDate] = useState('');
  const [user, setUser] = useState(null);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return unsubscribe;
  }, []);

  // Build a Timestamp at local midnight to avoid timezone shift
  const buildLocalMidnightTimestamp = (yyyyMmDd) => {
    const [y, m, d] = yyyyMmDd.split('-').map(Number);
    const local = new Date(y, m - 1, d, 0, 0, 0, 0); // local midnight
    return Timestamp.fromDate(local);
  };

  const handleAddReminder = async () => {
    const cleaned = text.trim();
    if (!cleaned || !date) {
      alert('Please enter both reminder text and date');
      return;
    }
    if (!user) {
      alert('You must be logged in to add reminders');
      return;
    }
    setAdding(true);
    try {
      await addDoc(collection(db, "reminders"), {
        userId: user.uid,
        text: cleaned,
        date: buildLocalMidnightTimestamp(date),
        createdAt: serverTimestamp(),
      });
      setText('');
      setDate('');
    } catch (error) {
      alert('Error adding reminder: ' + error.message);
    } finally {
      setAdding(false);
    }
  };

  return (
  <div
    style={{
      marginTop: '20px',
      padding: '15px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      backgroundColor: '#f9fafb',
      maxWidth: '400px',
    }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>Add Reminder</h2>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input
        type="text"
        placeholder="Reminder text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{
          padding: '10px',
          borderRadius: '6px',
          border: '1px solid #ccc',
          fontSize: '14px',
        }}
      />

      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        style={{
          padding: '10px',
          borderRadius: '6px',
          border: '1px solid #ccc',
          fontSize: '14px',
        }}
      />

      <button
        disabled={adding}
        onClick={handleAddReminder}
        style={{
          backgroundColor: adding ? '#6c757d' : '#91a58b',
          color: 'white',
          border: 'none',
          padding: '10px',
          borderRadius: '6px',
          cursor: adding ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s ease',
        }}
      >
        {adding ? 'Adding...' : 'Add Reminder'}
      </button>
    </div>
  </div>
);
}
export default ReminderInput;
